import { useState } from "react";
import { isAiEnabledSubject } from "../../AssignAiTestFlow";
import { buildLearningSummaryUrl } from "../../../Shared/utils/studentLinks";
import { fireEpicenterGtm } from "../../../../datalayers";

/**
 * Click handlers and open state for the two AI actions — "Learning summary"
 * and "Assign test". Shared by AIActionsDropdown, which renders both buttons
 * side by side, and ClassJoinCard, which splits them across Prepare and Teach.
 * The caller renders AILearningSummary / AssignAiTestFlow with this state.
 */
const useAIActions = ({ student, studentName, subject, batchId, courseName, source = "dashboard", opensSummaryPage = false, returnUrl }) => {
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [assignOpen, setAssignOpen] = useState(false);

  // Same tab: the page's Exit button returns here via returnUrl.
  const handleViewLearningSummary = () => {
    fireEpicenterGtm("AI_student_summary_opened", ["class", source, courseName]);
    if (opensSummaryPage) {
      window.location.assign(
        buildLearningSummaryUrl(batchId, {
          returnUrl: returnUrl ?? window.location.href,
          studentName: studentName ?? student?.studentName,
        }),
      );
      return;
    }
    setSummaryOpen(true);
  };

  // The assign-test flow supports Math and English; disable the action for
  // other subjects.
  const canAssignTest = isAiEnabledSubject(subject);

  const handleAssignTest = () => {
    fireEpicenterGtm("AI_test_assigned_opened", ["class", source, courseName]);
    setAssignOpen(true);
  };

  return {
    summaryOpen,
    assignOpen,
    canAssignTest,
    handleViewLearningSummary,
    handleAssignTest,
    closeSummary: () => setSummaryOpen(false),
    closeAssign: () => setAssignOpen(false),
  };
};

export default useAIActions;
